export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
export const MONTHS_FULL = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const STATUS = {
  advance: { label: "Advance", color: "#0891B2" },
  on_track: { label: "On Track", color: "#059669" },
  delay: { label: "Delay", color: "#D97706" },
  not_achieve: { label: "Not Achieve", color: "#E11D48" },
  no_data: { label: "Belum ada data", color: "#94A3B8" },
};
export const CATEGORIES = {
  P: { name: "Productivity", cls: "bg-blue-600 text-white" },
  Q: { name: "Quality", cls: "bg-purple-600 text-white" },
  C: { name: "Cost", cls: "bg-emerald-600 text-white" },
  D: { name: "Delivery", cls: "bg-amber-600 text-white" },
  S: { name: "Safety", cls: "bg-red-600 text-white" },
  M: { name: "Moral", cls: "bg-indigo-600 text-white" },
  E: { name: "Environment", cls: "bg-teal-600 text-white" },
  SK: { name: "Sikap Kerja", cls: "bg-slate-700 text-white" },
};
export const ROLES = { admin: "Admin", top: "CEO / Top Management", coo: "COO", manager: "Manager", spv: "SPV", staff: "Staff" };
export const roleLabel = (u) => (u ? [ROLES[u.role], u.secondary_role && u.secondary_role !== u.role ? ROLES[u.secondary_role] : null].filter(Boolean).join(" · ") : "");
export const KPI_TYPES = { mandatory: "Mandatory (PQCDSME)", sikap_kerja: "Sikap Kerja", initiative: "Initiative" };
export const IMP_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-200 text-slate-700" },
  submitted: { label: "Submitted", cls: "bg-blue-600 text-white" },
  revision: { label: "Perlu Revisi", cls: "bg-amber-500 text-white" },
  approved: { label: "Approved", cls: "bg-emerald-600 text-white" },
};
export const fmt = (v, d = 1) => (v === null || v === undefined ? "-" : Number(v).toLocaleString("id-ID", { maximumFractionDigits: d }));
export const pct = (v) => (v === null || v === undefined ? "-" : `${Number(v).toFixed(1)}%`);
export const CURRENT_YEAR = 2026;
export const YEARS = Array.from({ length: 2037 - 2025 + 1 }, (_, i) => 2025 + i);
